<template>
  <v-card id="listener_prelievi">
    <!-- Titolo del form -->
    <v-toolbar
      color="indigo"
      dense
      style="position: sticky; top: 0px; z-index: 1"
    >
      <v-toolbar-title class="white--text">Prelievi</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickProsegui()" small v-bind="attrs" v-on="on">
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
        </template>
        <span>Conferma</span>
      </v-tooltip> -->
      <v-spacer></v-spacer>
      <v-btn @click="clickChiudi" small>
        <v-icon color="error">mdi-keyboard-backspace</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="mt-5">
      <!-- Distinta base -->
      <v-row class="mb-10">
        <DistintaBase
          :headers_distinta="headers_distinta"
          :items_distinta_base="items_distinta_base"
          :items_distinta_prelievo="filtered_items_distinta_prelievo"
          style="width: 100%"
          :num_min_realizzabile="num_min_realizzabile"
          @prelievo_registrato="setCommessaImpegno"
          @prelievo_multiplo="setCommessaImpegnoMultiplo"
          :qta_realizzabile_autonoma="qta_realizzabile_autonoma"
          @ricarica_pagina="reload"
          @setqueryevent="handleSetQueryEvent"
          :fase_sel="fase_sel"
          :picking_allowed="picking_allowed"
        />
      </v-row>

      <v-divider class="mt-5"></v-divider>

      <!-- Distinta di prelievo -->
      <DistintaDiPrelievo
        :headers_prelievi="headers_prelievi"
        :items_distinta_prelievo="filtered_items_distinta_prelievo"
        :fase_sel="fase_sel"
        :picking_allowed="picking_allowed"
        @prelievo_registrato="setCommessaImpegno"
        @get_prelievi="getPrelieviCommessa"
        :show_add_form="true"
      />
    </v-card-text>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import DistintaBase from "@/components/PRODUCTION/Produzione/DistintaBase.vue";
import DistintaDiPrelievo from "@/components/PRODUCTION/Produzione/DistintaDiPrelievo.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "Prelievi",
  components: {
    DistintaBase,
    DistintaDiPrelievo,
    SnackbarQV,
  },
  props: {
    fase_sel: { type: Object, default: () => {} },
    picking_allowed: { type: Number, default: 1 },
    quantita: { type: Number, default: null },
    visibile: { type: Boolean, default: false },
    qta_realizzabile_autonoma: { type: Boolean, default: false },
    modulo_chiamante: { type: String, default: "" },
  },
  data() {
    return {
      overlay: false,
      headers_distinta: new Array(),
      headers_prelievi: new Array(),
      items_distinta_base: [],
      items_distinta_prelievo: [],
      num_min_realizzabile: 0,
    };
  },
  computed: {
    filtered_items_distinta_prelievo() {
      //debugger
      if (
        this.items_distinta_prelievo != null &&
        this.items_distinta_prelievo != ""
      ) {
        return this.items_distinta_prelievo.filter((i) => {
          return i.quantita_impegno > null;
        });
      } else {
        return new Array();
      }
    },
  },
  methods: {
    clickChiudi() {
      this.$emit("click_chiudi", true);
    },
    // clickProsegui() {
    //   this.$emit("click_prosegui");
    // },
    getPrelieviCommessa() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getprelievicommessa",
          token: localStorage.getItem("user_token"),
          id_commessa_dettaglio: this.fase_sel.id_commessa_dettaglio,
          quantita:
            this.quantita != null ? this.quantita : this.fase_sel.quantita,
          modulo_chiamante: this.modulo_chiamante,
          params: [
            {
              name: "id_commessa_dettaglio",
              value: this.fase_sel.id_commessa_dettaglio,
            },
            { name: "id_commessa", value: this.fase_sel.id_commessa },
          ],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          /* Emetto un evento per aggiornare le prop che il padre
           * mi passa (in particolare la quantità realizzabile). */
          this.$emit("aggiorna_work_orders");

          this.headers_distinta = res.data.header_prelievi
            ? res.data.header_prelievi
            : new Array();
          this.items_distinta_base = res.data.Distinta;

          this.headers_prelievi = res.data.header_impegni
            ? res.data.header_impegni
            : new Array();
          this.items_distinta_prelievo = res.data.Prelievi;

          /* Valorizzo la quantità realizzabile con il minimo
           * numero delle qta realizzabili nell'array; i dati
           * ritornati da questa chiamata ora non sono più
           * affidabili per via delle modifiche fatte per Inist.
           * Lasciamo comunque questa procedura e la variabile di
           * supporto con la prop che valorizza nel caso servano
           * in futuro. */
          let arr = Array.from(this.items_distinta_base);
          arr.sort(function (a, b) {
            return a.qta_realizzabile - b.qta_realizzabile;
          });
          this.num_min_realizzabile = arr[0].qta_realizzabile;
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
        });
    },
    handleSetQueryEvent() {
      this.$emit("setqueryevent");
    },
    setCommessaImpegno(arg) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessaimpegno",
          token: localStorage.getItem("user_token"),
          id_commessa: this.fase_sel.id_commessa,
          id_commessa_dettaglio: this.fase_sel.id_commessa_dettaglio,
          id_articolo: this.fase_sel.id_articolo,
          id_componente: arg.id_articolo,
          id_lotto: arg.id_lotto,
          cod_lotto: arg.cod_lotto,
          numero_seriale: arg.numero_seriale,
          quantita: arg.qta_prelevata,
          id_magazzino: arg.id_magazzino,
          coefficiente: arg.coeff !== 0 ? arg.coeff : undefined,
          // cod_articolo: this.fase_sel.cod_articolo,
          // id_componente: this.items_distinta_base[0].id_articolo,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$emit("aggiorna_work_orders");
            this.getPrelieviCommessa();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);

          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },

    setCommessaImpegnoMultiplo(arg) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessaimpegno",
          token: localStorage.getItem("user_token"),
          id_commessa: this.fase_sel.id_commessa,
          id_commessa_dettaglio: this.fase_sel.id_commessa_dettaglio,
          id_articolo: this.fase_sel.id_articolo,
          id_componente: arg.id_articolo,
          cod_lotto: arg.cod_lotto,
          id_lotto: arg.id_lotto,
          id_magazzino: arg.id_magazzino,
          numero_seriale: arg.numero_seriale,
          quantita: arg.qta_prelevata,
          coefficiente: arg.coeff !== 0 ? arg.coeff : undefined,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$emit("aggiorna_work_orders");
            this.getPrelieviCommessa();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);

          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },

    reload() {
      this.getPrelieviCommessa();
    },
  },
  mounted() {
    document
      .getElementById("listener_prelievi")
      .addEventListener("aggiornamento", this.getPrelieviCommessa);
  },
  watch: {
    visibile: {
      immediate: true,
      handler() {
        if (this.visibile === true) {
          this.getPrelieviCommessa();
        }
      },
    },
  },
};
</script>
<style>
</style>